import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/logo.png";
import { MdEmail } from "react-icons/md";
import { BsCalendar2DateFill } from "react-icons/bs";
import {
  FaFacebook,
  FaTwitter,
  FaInstagramSquare,
  FaYoutube,
  FaTiktok,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#f1f1f1] text-black pt-12 pb-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Logo and Subscribe */}
        <div className="space-y-4">
          <div className="flex items-center">
            <img src={logo} alt="Logo" className="h-12" />
          </div>
          <div className="space-y-4">
            <p className="text-black font-medium">Subscribe (Get Latest Offers)</p>
            <div className="relative">
              <MdEmail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black text-xl" />
              <input
                type="email"
                placeholder="Enter Your Email"
                className="w-full pl-10 pr-4 py-2 rounded-lg bg-white border focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>

        {/* Recent News */}
        <div className="space-y-4">
          <h2 className="text-xl font-bold text-black">Recent News</h2>
          <div className="space-y-4">
            <div className="border-l-2 border-blue-500 pl-4">
              <h4 className="text-black font-medium line-clamp-2">Title of the blog goes here - max two lines</h4>
              <p className="text-gray-600 text-sm flex items-center mt-1">
                <BsCalendar2DateFill className="mr-2" />
                01-31-2024
              </p>
            </div>
            <div className="border-l-2 border-blue-500 pl-4">
              <h4 className="text-black font-medium line-clamp-2">Title of the blog goes here - max two lines</h4>
              <p className="text-gray-600 text-sm flex items-center mt-1">
                <BsCalendar2DateFill className="mr-2" />
                01-31-2024
              </p>
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="space-y-4">
          <h2 className="text-xl font-bold text-black">Links</h2>
          <ul className="space-y-2">
            <li>
              <Link to="/about" className="text-gray-500 hover:text-black transition-colors">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/features" className="text-gray-500 hover:text-black transition-colors">
                Features
              </Link>
            </li>
            <li>
              <Link to="/solution" className="text-gray-500 hover:text-black transition-colors">
                Solution
              </Link>
            </li>
            <li>
              <Link to="/pricing" className="text-gray-500 hover:text-black transition-colors">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/blogs" className="text-gray-500 hover:text-black transition-colors">
                Blogs
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Form */}
        <div className="space-y-4">
          <h2 className="text-xl font-bold text-black">
            <span className="text-blue-400">Get in</span> Touch
          </h2>
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <input
                type="text"
                placeholder="First Name"
                className="w-full px-4 py-2 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                placeholder="Last Name"
                className="w-full px-4 py-2 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input
                type="email"
                placeholder="Email"
                className="w-full px-4 py-2 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="tel"
                placeholder="Phone"
                className="w-full px-4 py-2 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-black font-medium py-2 px-4 rounded-lg transition-colors">
              Send
            </button>
          </div>
        </div>
      </div>

      <hr className="border-gray-700 my-6" />

      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <p className="text-gray-700 text-sm mb-4 md:mb-0">
          Powered By - Support Care - Copyright 2024
        </p>
        <div className="flex space-x-4">
          <a href="https://www.facebook.com/" className="text-gray-800 hover:text-black transition-colors">
            <FaFacebook className="text-xl" />
          </a>
          <a href="https://twitter.com/" className="text-gray-800 hover:text-black transition-colors">
            <FaTwitter className="text-xl" />
          </a>
          <a href="https://www.instagram.com/" className="text-gray-800 hover:text-black transition-colors">
            <FaInstagramSquare className="text-xl" />
          </a>
          <a href="https://www.tiktok.com/" className="text-gray-800 hover:text-black transition-colors">
            <FaTiktok className="text-xl" />
          </a>
          <a href="https://www.youtube.com/" className="text-gray-800 hover:text-black transition-colors">
            <FaYoutube className="text-xl" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;